module.exports = __webpack_public_path__ + "img/vacuum-robot.15470f78.svg";